import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlatformService } from 'src/app/services/platform.service';

@Component({
  selector: 'vl-establish',
  standalone: true,
  imports: [],
  templateUrl: './establish.component.html',
  styleUrl: './establish.component.scss'
})
export class EstablishComponent {

  private platform: string = "";
  private accountId: string = "";
  private context: string = ""

  constructor(private activatedRoute: ActivatedRoute, private platformService: PlatformService) {
    this.activatedRoute.params.subscribe((params) => {
      this.platform = <string>params['platform'];
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      this.accountId = <string>params['accountId'];
      this.context = <string>params['context'];
    });
    const state = encodeURIComponent(JSON.stringify({
      accountId: this.accountId,
      context: this.context,
    }));
    const url = this.platformService.getAuthorizationUri(this.platform, state);
    location.replace(url);
    // (window as any).open(url, '_blank').focus();
  }

}
